module.exports = __webpack_public_path__ + "img/clouds_2_day.6a886136.svg";